export default __webpack_public_path__ + "static/waxseal-7d0daf920d39bb080e42cc9848984d6e.png";